import React, { useState } from "react"
import { InstantSearch, Configure, SearchBox } from "react-instantsearch"
import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter"
import { useTranslation, useI18next } from "gatsby-plugin-react-i18next"

import SearchResults from "./searchResults"

const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
  server: {
    apiKey: process.env.GATSBY_TYPESENSE_INDEX_API_KEY || "testing",
    nodes: [
      {
        host: process.env.GATSBY_TYPESENSE_HOST || "localhost",
        port: process.env.GATSBY_TYPESENSE_PORT || "8081",
        protocol: process.env.GATSBY_TYPESENSE_PROTOCOL || "http",
      },
    ],
  },
  additionalSearchParameters: {
    query_by: "title,summary,language",
  },
})
const searchClient = typesenseInstantsearchAdapter.searchClient

export default function SearchInterface() {
  const { language } = useI18next()
  const { t } = useTranslation()
  const [isSearchActive, setIsSearchActive] = useState(false)

  return (
    <>
      {isSearchActive ? (
        <>
          <div className="transition-all fixed after:w-full after:h-full m-auto top-0 left-0 bottom-0 right-0 flex after:fixed justify-around mt-20 after:top-0  after:bottom-0  after:right-0  after:left-0 after:content-[''] after:bg-slate-300 after:bg-opacity-90 after:z-0 after:w-full after:h-full">
            <InstantSearch
              searchClient={searchClient}
              indexName={
                process.env.GATSBY_TYPESENSE_INDEX || "ddp-internal-manual"
              }
            >
              <Configure
                analytics={false}
                filters={`language:${language}`}
                hitsPerPage={10}
              />
              <div className="z-20 relative">
                <button
                  aria-label="close search"
                  className="right-0 absolute -top-8 p-1 -right-5 bg-gray-700 rounded-full border-gray-600 border-2 shadow-md hover:bg-dark-sage"
                  onClick={() => setIsSearchActive(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={2}
                    stroke="currentColor"
                    className="w-4 h-4 text-gray-200 cursor-pointer"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
                <SearchBox
                  classNames={{
                    root: "group transition-all w-full min-w-[400px] max-w-[400px] sm:max-w-[600px]",
                    form: "relative w-100 mx-5",
                    input:
                      "block pl-6 pr-2 py-2 w-full bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 rounded-md text-dark-sage focus:ring-1",
                    submitIcon: "hidden",
                    resetIcon: "hidden",
                  }}
                  placeholder={t("search")}
                />
                <SearchResults setIsSearchActive={setIsSearchActive} />
              </div>
            </InstantSearch>
          </div>
        </>
      ) : (
        <button
          onClick={() => setIsSearchActive(true)}
          className="px-2 pt-1"
          aria-label={t("search")}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-5 h-5"
          >
            <path
              strokeLinecap="round"
              title={t("search")}
              strokeLinejoin="round"
              d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
            />
          </svg>
        </button>
      )}
    </>
  )
}
